<sk-modal-content [title]="'label.dms.DocumentTags' | translate"
                  [cancelBtnText]="'label.Cancel'"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <div class="table-container">
      <ag-grid-angular
        class="ag-theme-iris"
        [rowData]="tags()"
        [irisPagination]="false"
        [agGridFitWidth]="true"
        [gridOptions]="gridOptions"
      ></ag-grid-angular>
    </div>

    <form [formGroup]="addTagForm" class="add-tag-form" (ngSubmit)="addNewTag()">
      <span>{{ 'label.dms.AddNewTag' | translate }}</span>

      <div class="d-flex mt-3">
        <sk-text
          class="form-item"
          required
          [label]="'label.dms.TagName' | translate"
          formControlName="name"
          data-test="dms-select-tags-modal_tag-name"
        ></sk-text>
        <sk-select
          class="form-item"
          [label]="'label.dms.TagType' | translate"
          [items]="tagTypes"
          bindValue="name"
          bindLabel="label"
          formControlName="type"
          data-test="dms-select-tags-modal_tag-type"
        ></sk-select>
        <sk-color
          class="form-item"
          [label]="'label.Color' | translate"
          formControlName="color"
          data-test="dms-select-tags-modal_tag-color"
        ></sk-color>
      </div>

      @if (addTagForm.errors?.tagExists) {
        <mat-error class="sk">{{ 'error.dms.TagAlreadyExists' | translate }}</mat-error>
      }

      <div class="w-100 d-flex justify-content-end">
        <sk-button
          [appearance]="'outlined'"
          [color]="'primary'"
          [type]="'submit'"
          [label]="'label.dms.CreateTag' | translate"
          class="add-tag-btn"
          data-test="add-tag-btn"
          [disabled]="addTagForm.invalid"
        ></sk-button>
      </div>
    </form>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [label]="'label.Save' | translate"
      [color]="'primary'"
      data-test="modal-footer-confirm-button"
      (click)="saveFileWithTags()">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
